import { FileExtension, HttpCacheType, HttpContentType, HttpMethodType } from '../enums';
export const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.readAsDataURL(blob);
    });
};
export const bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const value = Math.floor(Math.log(bytes) / Math.log(1024));
    return value === 0
        ? `${bytes} ${sizes[value]}`
        : `${(bytes / Math.pow(1024, Math.floor(value))).toFixed(2)} ${sizes[value]}`;
};
export const convertBlobToFile = (name, blob) => {
    return Object.assign(blob, {
        name,
        lastModified: new Date().getDate(),
        lastModifiedDate: new Date(),
        webkitRelativePath: ''
    });
};
export const fetchImageBase64 = (imageUrl, 
/*istanbul ignore next*/
fetchWindow = window.fetch) => {
    const request = new Request(imageUrl, {
        method: HttpMethodType.GET,
        cache: HttpCacheType.NO_CACHE,
        headers: new Headers({
            Pragma: HttpCacheType.NO_CACHE
        })
    });
    return fetchWindow(request)
        .then(r => r.blob())
        .then(blob => convertBlobToBase64(blob));
};
function getMimeAndUint8Array(dataUrl) {
    const arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]);
    let n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return { mime, u8arr };
}
export function dataURLtoBlob(dataUrl) {
    const { mime, u8arr } = getMimeAndUint8Array(dataUrl);
    return new Blob([u8arr], { type: mime });
}
export function dataURLtoFile(dataUrl, fileName) {
    const blob = dataURLtoBlob(dataUrl);
    return convertBlobToFile(fileName, blob);
}
export function openPDF(response) {
    const { APPLICATION_PDF } = HttpContentType;
    const file = new Blob([response], { type: APPLICATION_PDF });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(file, 'MDxInvoice.pdf');
    }
    else {
        const fileURL = URL.createObjectURL(file);
        const pdfWindow = window.open();
        pdfWindow && (pdfWindow.location.href = fileURL);
    }
}
export const updateJpegImageFileNameExtension = (fileFullName) => {
    let updatedFileName = fileFullName;
    const fileExtension = getFileNameExtension(fileFullName);
    if (fileExtension.toUpperCase() === FileExtension.JPEG) {
        const fileNameWithoutExtension = getFileNameWithoutExtension(fileFullName);
        updatedFileName = `${fileNameWithoutExtension}.${FileExtension.JPG.toLowerCase()}`;
    }
    return updatedFileName;
};
const DOT_CHAR = '.';
export const getFileNameExtension = (fileFullName) => {
    return fileFullName.substring(fileFullName.lastIndexOf(DOT_CHAR) + 1);
};
export const getFileNameWithoutExtension = (fileFullName) => {
    return fileFullName.substring(0, fileFullName.lastIndexOf(DOT_CHAR));
};
export const getRenamedFile = (originalFile, newFileName) => {
    const blob = originalFile.slice(0, originalFile.size, originalFile.type);
    return new File([blob], newFileName, { type: originalFile.type });
};
/**
 * readFileAsText method will take @param file as parameter and returns the content in it as string
 */
export const readFileAsText = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.readAsText(file);
    });
};
//# sourceMappingURL=FileUtils.js.map